import { render, staticRenderFns } from "./PurchaseOrderAddressPanel.vue?vue&type=template&id=353850ef&"
import script from "./PurchaseOrderAddressPanel.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderAddressPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports